// extracted by mini-css-extract-plugin
export var calltoactioncontainer = "call-to-action-module--calltoactioncontainer--Ywkxn";
export var content = "call-to-action-module--content--Y-QgT";
export var buttons = "call-to-action-module--buttons--osBfk";